import 'es6-promise/auto'
import {
  createApp
} from 'vue'
import App from './App.vue'
import router from './router';
import store from './store';

import {
  IonicVue
} from '@ionic/vue';

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/* Theme variables */
import './theme/variables.css';


import axios from 'axios';
import { Preferences } from '@capacitor/preferences';


var apiUrl = process.env.VUE_APP_API;


console.log('apiUrl', apiUrl);

// default base url for axios
const defaultApi = 'http://localhost:8080/api/v1/';
if (!apiUrl) {
  console.warn('VUE_APP_API not set — using default API base URL:', defaultApi);
}
axios.defaults.baseURL = apiUrl|| defaultApi;

axios.interceptors.request.use(
  async (config) => {
      if (apiUrl?.includes("ngrok-free")) {
        config.headers["ngrok-skip-browser-warning"] = "true";
      }

      let token = await Preferences.get({
        key: '_userToken'
      });

      if (token.value) {
        config.headers['Authorization'] = `Bearer ${ JSON.parse(token.value).token }`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
);

const app = createApp(App)
  .use(IonicVue, { animated: false })
  .use(store)
  .use(router);

router.isReady().then(() => {
  app.mount('#app');
});

if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    let reloadingForUpdate = false;

    navigator.serviceWorker
      .register(`${process.env.BASE_URL}service-worker.js`, {
        updateViaCache: 'none',
      })
      .then((registration) => {
        // Ask for the newly deployed worker immediately instead of waiting for
        // the browser's periodic update check.
        registration.update();
        window.setInterval(() => registration.update(), 60 * 60 * 1000);

        navigator.serviceWorker.addEventListener('controllerchange', () => {
          if (reloadingForUpdate) return;

          reloadingForUpdate = true;
          window.location.reload();
        });
      })
      .catch((error) => {
        console.warn('Service worker registration failed:', error);
      });
  });
}
